"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-depth */
/* eslint-disable complexity */
/* eslint-disable max-len */
/* eslint-disable object-curly-newline, no-underscore-dangle, camelcase, no-unneeded-ternary */
var EventEmitter = require('../utils/events');
var helpers = require('../utils/helpers');
var RequestQueue = require('../utils/request-queue');
var MAX_URL_LENGTH = 2048;
function applyParams(parameters, options) {
  var apiKey = options.apiKey,
    version = options.version,
    sessionId = options.sessionId,
    clientId = options.clientId,
    userId = options.userId,
    segments = options.segments,
    testCells = options.testCells,
    requestMethod = options.requestMethod,
    beaconMode = options.beaconMode;
  var _helpers$getWindowLoc = helpers.getWindowLocation(),
    host = _helpers$getWindowLoc.host,
    pathname = _helpers$getWindowLoc.pathname,
    search = _helpers$getWindowLoc.search;
  var canonicalUrl = helpers.getCanonicalUrl();
  var documentReferrer = helpers.getDocumentReferrer();
  var sendReferrerWithTrackingEvents = options.sendReferrerWithTrackingEvents === false ? false : true; // Defaults to 'true'
  var aggregateParams = Object.assign(parameters);
  if (version) {
    aggregateParams.c = version;
  }
  if (clientId) {
    aggregateParams.i = clientId;
  }
  if (sessionId) {
    aggregateParams.s = sessionId;
  }
  if (userId) {
    aggregateParams.ui = String(userId);
  }
  if (segments && segments.length) {
    aggregateParams.us = segments;
  }
  if (apiKey) {
    aggregateParams.key = apiKey;
  }
  if (documentReferrer) {
    aggregateParams.document_referrer = documentReferrer;
  }
  if (canonicalUrl) {
    aggregateParams.canonical_url = canonicalUrl;
  }
  if (testCells) {
    Object.keys(testCells).forEach(function (testCellKey) {
      aggregateParams["ef-".concat(testCellKey)] = testCells[testCellKey];
    });
  }
  if (beaconMode && requestMethod && requestMethod.match(/POST/i)) {
    aggregateParams.beacon = true;
  }
  if (sendReferrerWithTrackingEvents && host) {
    aggregateParams.origin_referrer = host;
    if (pathname) {
      aggregateParams.origin_referrer += pathname;
    }
    if (search) {
      try {
        var utmQueryParamStrArr = [];
        var searchParams = new URLSearchParams(search);
        searchParams.forEach(function (value, key) {
          if (key.match(/utm_/)) {
            utmQueryParamStrArr.push("".concat(key, "=").concat(value));
          }
        });
        if (utmQueryParamStrArr.length) {
          aggregateParams.origin_referrer += "?".concat(utmQueryParamStrArr.join('&'));
        }
      } catch (e) {
        // Do nothing
      }
    }
  }
  aggregateParams._dt = Date.now();
  aggregateParams = helpers.cleanParams(aggregateParams);
  return aggregateParams;
}

// Append common parameters to supplied parameters object and return as string
function applyParamsAsString(parameters, options) {
  return helpers.stringify(applyParams(parameters, options));
}

/**
 * Interface to tracking related API calls
 *
 * @module tracker
 * @inner
 * @returns {object}
 */
var Tracker = /*#__PURE__*/function () {
  function Tracker(options) {
    (0, _classCallCheck2["default"])(this, Tracker);
    this.options = options || {};
    this.eventemitter = new EventEmitter();
    this.requests = new RequestQueue(options, this.eventemitter);
  }

  /**
   * Send session start event to API
   * @private
   * @function trackSessionStartV2
   * @param {object} [networkParameters] - Parameters relevant to the network request
   * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
   * @returns {(true|Error)}
   * @example
   * constructorio.tracker.trackSessionStartV2();
   */
  return (0, _createClass2["default"])(Tracker, [{
    key: "trackSessionStartV2",
    value: function trackSessionStartV2() {
      var networkParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = "".concat(this.options.serviceUrl, "/v2/behavioral_action/session_start?");
      this.requests.queue("".concat(url).concat(applyParamsAsString({}, this.options)), 'POST', undefined, networkParameters);
      this.requests.send();
      return true;
    }

    /**
     * Send session start event to API
     *
     * @function trackSessionStart
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @example
     * constructorio.tracker.trackSessionStart();
     */
  }, {
    key: "trackSessionStart",
    value: function trackSessionStart() {
      var networkParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = "".concat(this.options.serviceUrl, "/behavior?");
      var queryParams = {
        action: 'session_start'
      };
      this.requests.queue("".concat(url).concat(applyParamsAsString(queryParams, this.options)), undefined, undefined, networkParameters);
      this.requests.send();
      return true;
    }

    /**
     * Send input focus event to API
     * @private
     * @function trackInputFocusV2
     * @param {string} userInput - The current autocomplete search query
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User focused on search input element
     * @example
     * constructorio.tracker.trackInputFocusV2("text");
     */
  }, {
    key: "trackInputFocusV2",
    value: function trackInputFocusV2() {
      var userInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/focus?");
      var bodyParams = {};
      var _parameters$analytics = parameters.analyticsTags,
        analyticsTags = _parameters$analytics === void 0 ? null : _parameters$analytics;
      if (analyticsTags) {
        bodyParams.analytics_tags = analyticsTags;
      }
      bodyParams.user_input = userInput;
      var requestMethod = 'POST';
      var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
        requestMethod: requestMethod
      }));
      this.requests.queue("".concat(baseUrl).concat(applyParamsAsString({}, this.options)), requestMethod, requestBody, networkParameters);
      this.requests.send();
      return true;
    }

    /**
     * Send input focus event to API
     *
     * @function trackInputFocus
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User focused on search input element
     * @example
     * constructorio.tracker.trackInputFocus();
     */
  }, {
    key: "trackInputFocus",
    value: function trackInputFocus() {
      var networkParameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var url = "".concat(this.options.serviceUrl, "/behavior?");
      var queryParams = {
        action: 'focus'
      };
      this.requests.queue("".concat(url).concat(applyParamsAsString(queryParams, this.options)), undefined, undefined, networkParameters);
      this.requests.send();
      return true;
    }

    /**
     * Send item detail load event to API
     *
     * @function trackItemDetailLoad
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.itemName - Product item name
     * @param {string} parameters.itemId - Product item unique identifier
     * @param {string} parameters.url - Current page URL
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {string} [parameters.variationId] - Product item variation unique identifier
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User loaded an item detail page
     * @example
     * constructorio.tracker.trackItemDetailLoad(
     *     {
     *         itemName: 'Red T-Shirt',
     *         itemId: 'KMH876',
     *         url: 'https://constructor.io/product/KMH876',
     *     },
     * );
     */
  }, {
    key: "trackItemDetailLoad",
    value: function trackItemDetailLoad(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var requestUrlPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/item_detail_load?");
        var queryParams = {};
        var bodyParams = {};
        var item_name = parameters.item_name,
          name = parameters.name,
          item_id = parameters.item_id,
          customer_id = parameters.customer_id,
          _parameters$customerI = parameters.customerId,
          customerId = _parameters$customerI === void 0 ? customer_id : _parameters$customerI,
          variation_id = parameters.variation_id,
          _parameters$itemName = parameters.itemName,
          itemName = _parameters$itemName === void 0 ? item_name || name : _parameters$itemName,
          _parameters$itemId = parameters.itemId,
          itemId = _parameters$itemId === void 0 ? item_id || customerId : _parameters$itemId,
          _parameters$variation = parameters.variationId,
          variationId = _parameters$variation === void 0 ? variation_id : _parameters$variation,
          url = parameters.url,
          analyticsTags = parameters.analyticsTags;

        // Ensure support for both item_name and name as parameters
        if (itemName) {
          bodyParams.item_name = itemName;
        }

        // Ensure support for both item_id and customer_id as parameters
        if (itemId) {
          bodyParams.item_id = itemId;
        }
        if (variationId) {
          bodyParams.variation_id = variationId;
        }
        if (analyticsTags) {
          bodyParams.analytics_tags = analyticsTags;
        }
        if (url) {
          bodyParams.url = helpers.truncateString(url, MAX_URL_LENGTH);
        }
        var requestURL = "".concat(requestUrlPath).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send autocomplete select event to API
     * @private
     * @function trackAutocompleteSelectV2
     * @param {string} itemName - Name of selected autocomplete item
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.userInput - The current autocomplete search query
     * @param {string} [parameters.section] - Section the selected item resides within
     * @param {string} [parameters.tr] - Trigger used to select the item (click, etc.)
     * @param {string} [parameters.itemId] - Item id of the selected item
     * @param {string} [parameters.variationId] - Variation id of the selected item
     * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
     * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
     * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User selected (clicked, or navigated to via keyboard) a result that appeared within autocomplete
     * @example
     * constructorio.tracker.trackAutocompleteSelectV2(
     *     'T-Shirt',
     *      {
     *          userInput: 'Shirt',
     *          section: 'Products',
     *          tr: 'click',
     *          groupId: '88JU230',
     *          itemId: '12345',
     *          variationId: '12345-A',
     *          slCampaignId: 'Campaign 123',
     *          slCampaignOwner: 'Store 123',
     *      },
     * );
     */
  }, {
    key: "trackAutocompleteSelectV2",
    value: function trackAutocompleteSelectV2(itemName, parameters) {
      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // Ensure term is provided (required)
      if (itemName && typeof itemName === 'string') {
        // Ensure parameters are provided (required)
        if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
          var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/autocomplete_select?");
          var original_query = parameters.original_query,
            _parameters$originalQ = parameters.originalQuery,
            originalQuery = _parameters$originalQ === void 0 ? original_query : _parameters$originalQ,
            user_input = parameters.user_input,
            _parameters$userInput = parameters.userInput,
            userInput = _parameters$userInput === void 0 ? originalQuery || user_input : _parameters$userInput,
            original_section = parameters.original_section,
            _parameters$section = parameters.section,
            section = _parameters$section === void 0 ? original_section : _parameters$section,
            tr = parameters.tr,
            group_id = parameters.group_id,
            _parameters$groupId = parameters.groupId,
            groupId = _parameters$groupId === void 0 ? group_id : _parameters$groupId,
            item_id = parameters.item_id,
            _parameters$itemId2 = parameters.itemId,
            itemId = _parameters$itemId2 === void 0 ? item_id : _parameters$itemId2,
            variation_id = parameters.variation_id,
            _parameters$variation2 = parameters.variationId,
            variationId = _parameters$variation2 === void 0 ? variation_id : _parameters$variation2,
            slCampaignId = parameters.slCampaignId,
            slCampaignOwner = parameters.slCampaignOwner;
          var queryParams = {};
          var bodyParams = {
            user_input: userInput,
            tr: tr,
            group_id: groupId,
            item_id: itemId,
            variation_id: variationId,
            item_name: itemName,
            section: section
          };
          if (section) {
            queryParams.section = section;
          }
          if (slCampaignId) {
            bodyParams.sl_campaign_id = slCampaignId;
          }
          if (slCampaignOwner) {
            bodyParams.sl_campaign_owner = slCampaignOwner;
          }
          var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
          var requestMethod = 'POST';
          var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
            requestMethod: requestMethod
          }));
          this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
          this.requests.send();
          return true;
        }
        this.requests.send();
        return new Error('parameters are required of type object');
      }
      this.requests.send();
      return new Error('term is a required parameter of type string');
    }

    /**
     * Send autocomplete select event to API
     *
     * @function trackAutocompleteSelect
     * @param {string} term - Term of selected autocomplete item
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.originalQuery - The current autocomplete search query
     * @param {string} parameters.section - Section the selected item resides within
     * @param {string} [parameters.tr] - Trigger used to select the item (click, etc.)
     * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
     * @param {string} [parameters.displayName] - Display name of group of selected item
     * @param {string} [parameters.itemId] - Item id of the selected item
     * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
     * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User selected (clicked, or navigated to via keyboard) a result that appeared within autocomplete
     * @example
     * constructorio.tracker.trackAutocompleteSelect(
     *     'T-Shirt',
     *      {
     *         originalQuery: 'Shirt',
     *         section: 'Products',
     *         tr: 'click',
     *         groupId: '88JU230',
     *         displayName: 'apparel',
     *         itemId: '12345',
     *         slCampaignId: 'Campaign 123',
     *         slCampaignOwner: 'Store 123',
     *      },
     * );
     */
  }, {
    key: "trackAutocompleteSelect",
    value: function trackAutocompleteSelect(term, parameters) {
      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // Ensure term is provided (required)
      if (term && typeof term === 'string') {
        // Ensure parameters are provided (required)
        if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
          var url = "".concat(this.options.serviceUrl, "/autocomplete/").concat(helpers.encodeURIComponentRFC3986(helpers.trimNonBreakingSpaces(term)), "/select?");
          var queryParams = {};
          var original_query = parameters.original_query,
            _parameters$originalQ2 = parameters.originalQuery,
            originalQuery = _parameters$originalQ2 === void 0 ? original_query : _parameters$originalQ2,
            section = parameters.section,
            original_section = parameters.original_section,
            _parameters$originalS = parameters.originalSection,
            originalSection = _parameters$originalS === void 0 ? original_section : _parameters$originalS,
            tr = parameters.tr,
            group_id = parameters.group_id,
            _parameters$groupId2 = parameters.groupId,
            groupId = _parameters$groupId2 === void 0 ? group_id : _parameters$groupId2,
            display_name = parameters.display_name,
            _parameters$displayNa = parameters.displayName,
            displayName = _parameters$displayNa === void 0 ? display_name : _parameters$displayNa,
            item_id = parameters.item_id,
            _parameters$itemId3 = parameters.itemId,
            itemId = _parameters$itemId3 === void 0 ? item_id : _parameters$itemId3,
            slCampaignOwner = parameters.slCampaignOwner,
            slCampaignId = parameters.slCampaignId;
          if (originalQuery) {
            queryParams.original_query = originalQuery;
          }
          if (tr) {
            queryParams.tr = tr;
          }
          if (originalSection || section) {
            queryParams.section = originalSection || section;
          }
          if (groupId) {
            queryParams.group = {
              group_id: groupId,
              display_name: displayName
            };
          }
          if (itemId) {
            queryParams.item_id = itemId;
          }
          if (slCampaignId) {
            queryParams.sl_campaign_id = slCampaignId;
          }
          if (slCampaignOwner) {
            queryParams.sl_campaign_owner = slCampaignOwner;
          }
          this.requests.queue("".concat(url).concat(applyParamsAsString(queryParams, this.options)), undefined, undefined, networkParameters);
          this.requests.send();
          return true;
        }
        this.requests.send();
        return new Error('parameters are required of type object');
      }
      this.requests.send();
      return new Error('term is a required parameter of type string');
    }

    /**
     * Send autocomplete search event to API
     * @private
     * @function trackSearchSubmitV2
     * @param {string} searchTerm - Term of submitted autocomplete event
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.userInput - The current autocomplete search query
     * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User submitted a search (pressing enter within input element, or clicking submit element)
     * @example
     * constructorio.tracker.trackSearchSubmitV2(
     *     'T-Shirt',
     *     {
     *         userInput: 'Shirt',
     *         groupId: '88JU230',
     *     },
     * );
     */
  }, {
    key: "trackSearchSubmitV2",
    value: function trackSearchSubmitV2(searchTerm, parameters) {
      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // Ensure term is provided (required)
      if (searchTerm && typeof searchTerm === 'string') {
        // Ensure parameters are provided (required)
        if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
          var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_submit?");
          var original_query = parameters.original_query,
            _parameters$originalQ3 = parameters.originalQuery,
            originalQuery = _parameters$originalQ3 === void 0 ? original_query : _parameters$originalQ3,
            user_input = parameters.user_input,
            _parameters$userInput2 = parameters.userInput,
            userInput = _parameters$userInput2 === void 0 ? originalQuery || user_input : _parameters$userInput2,
            group_id = parameters.group_id,
            _parameters$groupId3 = parameters.groupId,
            groupId = _parameters$groupId3 === void 0 ? group_id : _parameters$groupId3,
            section = parameters.section,
            _parameters$analytics2 = parameters.analyticsTags,
            analyticsTags = _parameters$analytics2 === void 0 ? null : _parameters$analytics2;
          var queryParams = {};
          var bodyParams = {
            user_input: userInput,
            search_term: searchTerm,
            section: section
          };
          if (groupId) {
            bodyParams.filters = {
              group_id: groupId
            };
          }
          if (section) {
            queryParams.section = section;
          }
          if (analyticsTags) {
            bodyParams.analytics_tags = analyticsTags;
          }
          var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
          var requestMethod = 'POST';
          var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
            requestMethod: requestMethod
          }));
          this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
          this.requests.send();
          return true;
        }
        this.requests.send();
        return new Error('parameters are required of type object');
      }
      this.requests.send();
      return new Error('term is a required parameter of type string');
    }

    /**
     * Send autocomplete search event to API
     *
     * @function trackSearchSubmit
     * @param {string} term - Term of submitted autocomplete event
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.originalQuery - The current autocomplete search query
     * @param {string} [parameters.groupId] - Group identifier of the group to search within. Only required if searching within a group, i.e. "Pumpkin in Canned Goods"
     * @param {string} [parameters.displayName] - Display name of group of selected item
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User submitted a search (pressing enter within input element, or clicking submit element)
     * @example
     * constructorio.tracker.trackSearchSubmit(
     *     'T-Shirt',
     *     {
     *         originalQuery: 'Shirt',
     *         groupId: '88JU230',
     *         displayName: 'apparel',
     *     },
     * );
     */
  }, {
    key: "trackSearchSubmit",
    value: function trackSearchSubmit(term, parameters) {
      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // Ensure term is provided (required)
      if (term && typeof term === 'string') {
        // Ensure parameters are provided (required)
        if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
          var url = "".concat(this.options.serviceUrl, "/autocomplete/").concat(helpers.encodeURIComponentRFC3986(helpers.trimNonBreakingSpaces(term)), "/search?");
          var queryParams = {};
          var original_query = parameters.original_query,
            _parameters$originalQ4 = parameters.originalQuery,
            originalQuery = _parameters$originalQ4 === void 0 ? original_query : _parameters$originalQ4,
            group_id = parameters.group_id,
            _parameters$groupId4 = parameters.groupId,
            groupId = _parameters$groupId4 === void 0 ? group_id : _parameters$groupId4,
            display_name = parameters.display_name,
            _parameters$displayNa2 = parameters.displayName,
            displayName = _parameters$displayNa2 === void 0 ? display_name : _parameters$displayNa2,
            analyticsTags = parameters.analyticsTags;
          if (originalQuery) {
            queryParams.original_query = originalQuery;
          }
          if (groupId) {
            queryParams.group = {
              group_id: groupId,
              display_name: displayName
            };
          }
          if (analyticsTags) {
            queryParams.analytics_tags = analyticsTags;
          }
          this.requests.queue("".concat(url).concat(applyParamsAsString(queryParams, this.options)), undefined, undefined, networkParameters);
          this.requests.send();
          return true;
        }
        this.requests.send();
        return new Error('parameters are required of type object');
      }
      this.requests.send();
      return new Error('term is a required parameter of type string');
    }

    /**
     * Send search results loaded event to API
     *
     * @function trackSearchResultsLoaded
     * @param {string} searchTerm - Search results query term
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.url - URL of the search results page
     * @param {object[]} parameters.items - List of product item unique identifiers in search results listing
     * @param {number} [parameters.resultCount] - Total number of results
     * @param {number} [parameters.resultPage] - Current page of search results
     * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
     * @param {object} [parameters.selectedFilters] - Selected filters
     * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
     * @param {string} [parameters.sortBy] - Sorting method
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User viewed a search product listing page
     * @example
     * constructorio.tracker.trackSearchResultsLoaded(
     *     'T-Shirt',
     *     {
     *         resultCount: 167,
     *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
     *         sortOrder: 'ascending'
     *         sortBy: 'price',
     *         resultPage: 3,
     *         resultCount: 20
     *     },
     * );
     */
  }, {
    key: "trackSearchResultsLoaded",
    value: function trackSearchResultsLoaded(searchTerm, parameters) {
      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // Ensure term is provided (required)
      if (searchTerm && typeof searchTerm === 'string') {
        // Ensure parameters are provided (required)
        if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
          var _helpers$getWindowLoc2, _ref, _ref2;
          var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_result_load?");
          var num_results = parameters.num_results,
            _parameters$numResult = parameters.numResults,
            numResults = _parameters$numResult === void 0 ? num_results : _parameters$numResult,
            result_count = parameters.result_count,
            customerIds = parameters.customerIds,
            _parameters$customer_ = parameters.customer_ids,
            customer_ids = _parameters$customer_ === void 0 ? customerIds : _parameters$customer_,
            itemIds = parameters.itemIds,
            _parameters$item_ids = parameters.item_ids,
            item_ids = _parameters$item_ids === void 0 ? itemIds : _parameters$item_ids,
            _parameters$items = parameters.items,
            items = _parameters$items === void 0 ? customer_ids || item_ids : _parameters$items,
            result_page = parameters.result_page,
            _parameters$resultPag = parameters.resultPage,
            resultPage = _parameters$resultPag === void 0 ? result_page : _parameters$resultPag,
            result_id = parameters.result_id,
            _parameters$resultId = parameters.resultId,
            resultId = _parameters$resultId === void 0 ? result_id : _parameters$resultId,
            sort_order = parameters.sort_order,
            _parameters$sortOrder = parameters.sortOrder,
            sortOrder = _parameters$sortOrder === void 0 ? sort_order : _parameters$sortOrder,
            sort_by = parameters.sort_by,
            _parameters$sortBy = parameters.sortBy,
            sortBy = _parameters$sortBy === void 0 ? sort_by : _parameters$sortBy,
            selected_filters = parameters.selected_filters,
            _parameters$selectedF = parameters.selectedFilters,
            selectedFilters = _parameters$selectedF === void 0 ? selected_filters : _parameters$selectedF,
            _parameters$url = parameters.url,
            url = _parameters$url === void 0 ? ((_helpers$getWindowLoc2 = helpers.getWindowLocation()) === null || _helpers$getWindowLoc2 === void 0 ? void 0 : _helpers$getWindowLoc2.href) || 'N/A' : _parameters$url,
            section = parameters.section,
            analyticsTags = parameters.analyticsTags,
            _parameters$resultCou = parameters.resultCount,
            resultCount = _parameters$resultCou === void 0 ? (_ref = (_ref2 = numResults !== null && numResults !== void 0 ? numResults : result_count) !== null && _ref2 !== void 0 ? _ref2 : items === null || items === void 0 ? void 0 : items.length) !== null && _ref !== void 0 ? _ref : 0 : _parameters$resultCou;
          var queryParams = {};
          var transformedItems;
          if (items && Array.isArray(items) && items.length !== 0) {
            var trimmedItems = items.slice(0, 100);
            if (typeof items[0] === 'string' || typeof items[0] === 'number') {
              transformedItems = trimmedItems.map(function (itemId) {
                return {
                  item_id: String(itemId)
                };
              });
            } else {
              transformedItems = trimmedItems.map(function (item) {
                return helpers.toSnakeCaseKeys(item, false);
              });
            }
          }
          if (section) {
            queryParams.section = section;
          }
          var bodyParams = {
            search_term: searchTerm,
            result_count: resultCount,
            items: transformedItems,
            result_page: resultPage,
            result_id: resultId,
            sort_order: sortOrder,
            sort_by: sortBy,
            selected_filters: selectedFilters,
            url: helpers.truncateString(url, MAX_URL_LENGTH),
            section: section,
            analytics_tags: analyticsTags
          };
          var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
          var requestMethod = 'POST';
          var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
            requestMethod: requestMethod
          }));
          this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
          this.requests.send();
          return true;
        }
        this.requests.send();
        return new Error('parameters are required of type object');
      }
      this.requests.send();
      return new Error('term is a required parameter of type string');
    }

    /**
     * Send click through event to API
     * @private
     * @function trackSearchResultClickV2
     * @param {string} searchTerm - Search results query term
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.itemName - Product item name (Either itemName or itemId is required)
     * @param {string} parameters.itemId - Product item unique identifier
     * @param {string} [parameters.variationId] - Product item variation unique identifier
     * @param {string} [parameters.resultId] - Search result identifier (returned in response from Constructor)
     * @param {number} [parameters.resultCount] - Number of results in total
     * @param {number} [parameters.resultPage] - Current page of results
     * @param {string} [parameters.resultPositionOnPage] - Position of selected items on page
     * @param {string} [parameters.numResultsPerPage] - Number of results per page
     * @param {object} [parameters.selectedFilters] - Key - Value map of selected filters
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
     * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User clicked a result that appeared within a search product listing page
     * @example
     * constructorio.tracker.trackSearchResultClickV2(
     *     'T-Shirt',
     *     {
     *         itemName: 'Red T-Shirt',
     *         itemId: 'KMH876',
     *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         slCampaignId: 'Campaign 123',
     *         slCampaignOwner: 'Store 123',
     *     },
     * );
     */
  }, {
    key: "trackSearchResultClickV2",
    value: function trackSearchResultClickV2(searchTerm, parameters) {
      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // Ensure term is provided (required)
      if (searchTerm && typeof searchTerm === 'string') {
        // Ensure parameters are provided (required)
        if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
          var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/search_result_click?");
          var num_results = parameters.num_results,
            customer_id = parameters.customer_id,
            item_id = parameters.item_id,
            _parameters$itemId4 = parameters.itemId,
            itemId = _parameters$itemId4 === void 0 ? customer_id || item_id : _parameters$itemId4,
            name = parameters.name,
            item_name = parameters.item_name,
            _parameters$itemName2 = parameters.itemName,
            itemName = _parameters$itemName2 === void 0 ? name || item_name : _parameters$itemName2,
            variation_id = parameters.variation_id,
            _parameters$variation3 = parameters.variationId,
            variationId = _parameters$variation3 === void 0 ? variation_id : _parameters$variation3,
            result_id = parameters.result_id,
            _parameters$resultId2 = parameters.resultId,
            resultId = _parameters$resultId2 === void 0 ? result_id : _parameters$resultId2,
            result_count = parameters.result_count,
            _parameters$resultCou2 = parameters.resultCount,
            resultCount = _parameters$resultCou2 === void 0 ? num_results || result_count : _parameters$resultCou2,
            result_page = parameters.result_page,
            _parameters$resultPag2 = parameters.resultPage,
            resultPage = _parameters$resultPag2 === void 0 ? result_page : _parameters$resultPag2,
            result_position_on_page = parameters.result_position_on_page,
            _parameters$resultPos = parameters.resultPositionOnPage,
            resultPositionOnPage = _parameters$resultPos === void 0 ? result_position_on_page : _parameters$resultPos,
            num_results_per_page = parameters.num_results_per_page,
            _parameters$numResult2 = parameters.numResultsPerPage,
            numResultsPerPage = _parameters$numResult2 === void 0 ? num_results_per_page : _parameters$numResult2,
            selected_filters = parameters.selected_filters,
            _parameters$selectedF2 = parameters.selectedFilters,
            selectedFilters = _parameters$selectedF2 === void 0 ? selected_filters : _parameters$selectedF2,
            section = parameters.section,
            analyticsTags = parameters.analyticsTags,
            slCampaignId = parameters.slCampaignId,
            slCampaignOwner = parameters.slCampaignOwner;
          var bodyParams = {
            sl_campaign_id: slCampaignId,
            sl_campaign_owner: slCampaignOwner,
            item_name: itemName,
            item_id: itemId,
            variation_id: variationId,
            result_id: resultId,
            result_count: resultCount,
            result_page: resultPage,
            result_position_on_page: resultPositionOnPage,
            num_results_per_page: numResultsPerPage,
            selected_filters: selectedFilters,
            section: section,
            search_term: searchTerm,
            analytics_tags: analyticsTags
          };
          var queryParams = {};
          if (section) {
            queryParams.section = section;
          }
          var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
          var requestMethod = 'POST';
          var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
            requestMethod: requestMethod
          }));
          this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
          this.requests.send();
          return true;
        }
        this.requests.send();
        return new Error('parameters are required of type object');
      }
      this.requests.send();
      return new Error('term is a required parameter of type string');
    }

    /**
     * Send click through event to API
     *
     * @function trackSearchResultClick
     * @param {string} term - Search results query term
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.itemName - Product item name
     * @param {string} parameters.itemId - Product item unique identifier
     * @param {string} [parameters.variationId] - Product item variation unique identifier
     * @param {string} [parameters.resultId] - Search result identifier (returned in response from Constructor)
     * @param {string} [parameters.itemIsConvertible] - Whether or not an item is available for a conversion
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
     * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User clicked a result that appeared within a search product listing page
     * @example
     * constructorio.tracker.trackSearchResultClick(
     *     'T-Shirt',
     *     {
     *         itemName: 'Red T-Shirt',
     *         itemId: 'KMH876',
     *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         slCampaignId: 'Campaign 123',
     *         slCampaignOwner: 'Store 123',
     *     },
     * );
     */
  }, {
    key: "trackSearchResultClick",
    value: function trackSearchResultClick(term, parameters) {
      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // Ensure term is provided (required)
      if (term && typeof term === 'string') {
        // Ensure parameters are provided (required)
        if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
          var url = "".concat(this.options.serviceUrl, "/autocomplete/").concat(helpers.encodeURIComponentRFC3986(helpers.trimNonBreakingSpaces(term)), "/click_through?");
          var queryParams = {};
          var item_name = parameters.item_name,
            name = parameters.name,
            _parameters$itemName3 = parameters.itemName,
            itemName = _parameters$itemName3 === void 0 ? item_name || name : _parameters$itemName3,
            item_id = parameters.item_id,
            _parameters$itemId5 = parameters.itemId,
            itemId = _parameters$itemId5 === void 0 ? item_id : _parameters$itemId5,
            customer_id = parameters.customer_id,
            _parameters$customerI2 = parameters.customerId,
            customerId = _parameters$customerI2 === void 0 ? customer_id || itemId : _parameters$customerI2,
            variation_id = parameters.variation_id,
            _parameters$variation4 = parameters.variationId,
            variationId = _parameters$variation4 === void 0 ? variation_id : _parameters$variation4,
            result_id = parameters.result_id,
            _parameters$resultId3 = parameters.resultId,
            resultId = _parameters$resultId3 === void 0 ? result_id : _parameters$resultId3,
            item_is_convertible = parameters.item_is_convertible,
            _parameters$itemIsCon = parameters.itemIsConvertible,
            itemIsConvertible = _parameters$itemIsCon === void 0 ? item_is_convertible : _parameters$itemIsCon,
            section = parameters.section,
            analyticsTags = parameters.analyticsTags,
            slCampaignOwner = parameters.slCampaignOwner,
            slCampaignId = parameters.slCampaignId;

          // Ensure support for both item_name and name as parameters
          if (itemName) {
            queryParams.name = itemName;
          }

          // Ensure support for both item_id and customer_id as parameters
          if (customerId) {
            queryParams.customer_id = customerId;
          }
          if (variationId) {
            queryParams.variation_id = variationId;
          }
          if (resultId) {
            queryParams.result_id = resultId;
          }
          if (typeof itemIsConvertible === 'boolean') {
            queryParams.item_is_convertible = itemIsConvertible;
          }
          if (section) {
            queryParams.section = section;
          }
          if (analyticsTags) {
            queryParams.analytics_tags = analyticsTags;
          }
          if (slCampaignId) {
            queryParams.sl_campaign_id = slCampaignId;
          }
          if (slCampaignOwner) {
            queryParams.sl_campaign_owner = slCampaignOwner;
          }
          this.requests.queue("".concat(url).concat(applyParamsAsString(queryParams, this.options)), undefined, undefined, networkParameters);
          this.requests.send();
          return true;
        }
        this.requests.send();
        return new Error('parameters are required of type object');
      }
      this.requests.send();
      return new Error('term is a required parameter of type string');
    }

    /**
     * Send conversion event to API
     *
     * @function trackConversion
     * @param {string} [term] - Search results query term that led to conversion event
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.itemId - Product item unique identifier
     * @param {number} [parameters.revenue] - Sale price if available, otherwise the regular (retail) price of item
     * @param {string} [parameters.itemName] - Product item name
     * @param {string} [parameters.variationId] - Product item variation unique identifier
     * @param {string} [parameters.type='add_to_cart'] - Conversion type
     * @param {boolean} [parameters.isCustomType] - Specify if type is custom conversion type
     * @param {string} [parameters.displayName] - Display name for the custom conversion type
     * @param {string} [parameters.section="Products"] - Index section
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User performed an action indicating interest in an item (add to cart, add to wishlist, etc.)
     * @see https://docs.constructor.com/docs/integrating-with-constructor-behavioral-tracking-data-driven-event-tracking
     * @example
     * constructorio.tracker.trackConversion(
     *     'T-Shirt',
     *     {
     *         itemId: 'KMH876',
     *         revenue: 12.00,
     *         itemName: 'Red T-Shirt',
     *         variationId: 'KMH879-7632',
     *         type: 'like',
     *         section: 'Products',
     *     },
     * );
     */
  }, {
    key: "trackConversion",
    value: function trackConversion(term, parameters) {
      var networkParameters = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var searchTerm = term || 'TERM_UNKNOWN';
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/conversion?");
        var queryParams = {};
        var bodyParams = {};
        var name = parameters.name,
          item_name = parameters.item_name,
          _parameters$itemName4 = parameters.itemName,
          itemName = _parameters$itemName4 === void 0 ? item_name || name : _parameters$itemName4,
          customer_id = parameters.customer_id,
          _parameters$customerI3 = parameters.customerId,
          customerId = _parameters$customerI3 === void 0 ? customer_id : _parameters$customerI3,
          item_id = parameters.item_id,
          _parameters$itemId6 = parameters.itemId,
          itemId = _parameters$itemId6 === void 0 ? item_id || customerId : _parameters$itemId6,
          variation_id = parameters.variation_id,
          _parameters$variation5 = parameters.variationId,
          variationId = _parameters$variation5 === void 0 ? variation_id : _parameters$variation5,
          revenue = parameters.revenue,
          _parameters$section2 = parameters.section,
          section = _parameters$section2 === void 0 ? 'Products' : _parameters$section2,
          display_name = parameters.display_name,
          _parameters$displayNa3 = parameters.displayName,
          displayName = _parameters$displayNa3 === void 0 ? display_name : _parameters$displayNa3,
          type = parameters.type,
          is_custom_type = parameters.is_custom_type,
          _parameters$isCustomT = parameters.isCustomType,
          isCustomType = _parameters$isCustomT === void 0 ? is_custom_type : _parameters$isCustomT;

        // Ensure support for both item_id and customer_id as parameters
        if (itemId) {
          bodyParams.item_id = itemId;
        }

        // Ensure support for both item_name and name as parameters
        if (itemName) {
          bodyParams.item_name = itemName;
        }
        if (variationId) {
          bodyParams.variation_id = variationId;
        }
        if (revenue || revenue === 0) {
          bodyParams.revenue = revenue.toString();
        }
        if (section) {
          queryParams.section = section;
          bodyParams.section = section;
        }
        if (searchTerm) {
          bodyParams.search_term = searchTerm;
        }
        if (type) {
          bodyParams.type = type;
        }
        if (isCustomType) {
          bodyParams.is_custom_type = isCustomType;
        }
        if (displayName) {
          bodyParams.display_name = displayName;
        }
        var requestURL = "".concat(requestPath).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send purchase event to API
     *
     * @function trackPurchase
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {Array.<{itemId: string | undefined,
     * variationId: string | undefined,
     * itemName: string | undefined,
     * count: number | undefined,
     * price: number | undefined}>} parameters.items - List of product item objects
     * @param {number} parameters.revenue - The subtotal (excluding taxes, shipping, etc.) of the entire order
     * @param {string} [parameters.orderId] - Unique order identifier
     * @param {string} [parameters.section="Products"] - Index section
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User completed an order (usually fired on order confirmation page)
     * @example
     * constructorio.tracker.trackPurchase(
     *     {
     *         items: [{ itemId: 'KMH876', price: 1, count: 1}, { itemId: 'KMH140', price: 1, count: 1s }],
     *         revenue: 12.00,
     *         orderId: 'OUNXBG2HMA',
     *         section: 'Products',
     *     },
     * );
     */
  }, {
    key: "trackPurchase",
    value: function trackPurchase(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/purchase?");
        var queryParams = {};
        var bodyParams = {};
        var items = parameters.items,
          revenue = parameters.revenue,
          order_id = parameters.order_id,
          _parameters$orderId = parameters.orderId,
          orderId = _parameters$orderId === void 0 ? order_id : _parameters$orderId,
          section = parameters.section,
          analyticsTags = parameters.analyticsTags;
        var apiKey = this.options.apiKey;
        if (orderId) {
          // Don't send another purchase event if we have already tracked the order for the current key
          if (helpers.hasOrderIdRecord({
            orderId: orderId,
            apiKey: apiKey
          })) {
            return false;
          }
          helpers.addOrderIdRecord({
            orderId: orderId,
            apiKey: apiKey
          });

          // Add order_id to the tracking params
          bodyParams.order_id = orderId;
        }
        if (items && Array.isArray(items)) {
          bodyParams.items = items.slice(0, 100).map(function (item) {
            return helpers.toSnakeCaseKeys(item, false);
          });
        }
        if (revenue || revenue === 0) {
          bodyParams.revenue = revenue;
        }
        if (section) {
          queryParams.section = section;
        } else {
          queryParams.section = 'Products';
        }
        if (analyticsTags) {
          bodyParams.analytics_tags = analyticsTags;
        }
        var requestURL = "".concat(requestPath).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send recommendation view event to API
     *
     * @function trackRecommendationView
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.url - Current page URL
     * @param {string} parameters.podId - Pod identifier
     * @param {number} parameters.numResultsViewed - Number of results viewed
     * @param {object[]} [parameters.items] - List of Product Item Objects
     * @param {number} [parameters.resultCount] - Total number of results
     * @param {number} [parameters.resultPage] - Page number of results
     * @param {string} [parameters.resultId] - Recommendation result identifier (returned in response from Constructor)
     * @param {string} [parameters.section="Products"] - Results section
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {string[]|string|number} [parameters.seedItemIds] - Item ID(s) to be used as seed
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User viewed a set of recommendations
     * @example
     * constructorio.tracker.trackRecommendationView(
     *     {
     *         items: [{ itemId: 'KMH876' }, { itemId: 'KMH140' }],
     *         resultCount: 22,
     *         resultPage: 2,
     *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         url: 'https://demo.constructor.io/sandbox/farmstand',
     *         podId: '019927c2-f955-4020',
     *         numResultsViewed: 3,
     *     },
     * );
     */
  }, {
    key: "trackRecommendationView",
    value: function trackRecommendationView(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/recommendation_result_view?");
        var bodyParams = {};
        var result_count = parameters.result_count,
          result_page = parameters.result_page,
          _parameters$resultPag3 = parameters.resultPage,
          resultPage = _parameters$resultPag3 === void 0 ? result_page : _parameters$resultPag3,
          result_id = parameters.result_id,
          _parameters$resultId4 = parameters.resultId,
          resultId = _parameters$resultId4 === void 0 ? result_id : _parameters$resultId4,
          section = parameters.section,
          url = parameters.url,
          pod_id = parameters.pod_id,
          _parameters$podId = parameters.podId,
          podId = _parameters$podId === void 0 ? pod_id : _parameters$podId,
          num_results_viewed = parameters.num_results_viewed,
          _parameters$numResult3 = parameters.numResultsViewed,
          numResultsViewed = _parameters$numResult3 === void 0 ? num_results_viewed : _parameters$numResult3,
          items = parameters.items,
          analyticsTags = parameters.analyticsTags,
          seedItemIds = parameters.seedItemIds,
          _parameters$resultCou3 = parameters.resultCount,
          resultCount = _parameters$resultCou3 === void 0 ? result_count || (items === null || items === void 0 ? void 0 : items.length) || 0 : _parameters$resultCou3;
        if (!helpers.isNil(resultCount)) {
          bodyParams.result_count = resultCount;
        }
        if (!helpers.isNil(resultPage)) {
          bodyParams.result_page = resultPage;
        }
        if (resultId) {
          bodyParams.result_id = resultId;
        }
        if (section) {
          bodyParams.section = section;
        } else {
          bodyParams.section = 'Products';
        }
        if (url) {
          bodyParams.url = helpers.truncateString(url, MAX_URL_LENGTH);
        }
        if (podId) {
          bodyParams.pod_id = podId;
        }
        if (!helpers.isNil(numResultsViewed)) {
          bodyParams.num_results_viewed = numResultsViewed;
        }
        if (items && Array.isArray(items)) {
          bodyParams.items = items.slice(0, 100).map(function (item) {
            return helpers.toSnakeCaseKeys(item, false);
          });
        }
        if (analyticsTags) {
          bodyParams.analytics_tags = analyticsTags;
        }
        if (typeof seedItemIds === 'number') {
          bodyParams.seed_item_ids = [String(seedItemIds)];
        } else if (seedItemIds !== null && seedItemIds !== void 0 && seedItemIds.length && typeof seedItemIds === 'string') {
          bodyParams.seed_item_ids = [seedItemIds];
        } else if (seedItemIds !== null && seedItemIds !== void 0 && seedItemIds.length && Array.isArray(seedItemIds)) {
          bodyParams.seed_item_ids = seedItemIds;
        }
        var requestURL = "".concat(requestPath).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send media impression view event to API
     *
     * @function trackMediaImpressionView
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.bannerAdId - Banner ad identifier
     * @param {string} parameters.placementId - Placement identifier
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User viewed a media banner
     * @example
     * constructorio.tracker.trackMediaImpressionView(
     *     {
     *         bannerAdId: 'banner_ad_id',
     *         placementId: 'placement_id',
     *     },
     * );
     */
  }, {
    key: "trackMediaImpressionView",
    value: function trackMediaImpressionView(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var baseUrl = new URL(this.options.mediaServiceUrl);
        if (!baseUrl.hostname.startsWith('behavior')) {
          baseUrl.hostname = "behavior.".concat(baseUrl.hostname);
        }
        var requestPath = "".concat(baseUrl.toString(), "v2/ad_behavioral_action/display_ad_view?");
        var bodyParams = {};
        var bannerAdId = parameters.bannerAdId,
          placementId = parameters.placementId,
          analyticsTags = parameters.analyticsTags;
        if (!helpers.isNil(bannerAdId)) {
          bodyParams.banner_ad_id = bannerAdId;
        }
        if (!helpers.isNil(placementId)) {
          bodyParams.placement_id = placementId;
        }
        if (!helpers.isNil(analyticsTags)) {
          bodyParams.analytics_tags = analyticsTags;
        }
        var requestURL = "".concat(requestPath).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send recommendation click event to API
     *
     * @function trackRecommendationClick
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.podId - Pod identifier
     * @param {string} parameters.strategyId - Strategy identifier
     * @param {string} parameters.itemId - Product item unique identifier
     * @param {string} parameters.itemName - Product item name
     * @param {string} [parameters.variationId] - Product item variation unique identifier
     * @param {string} [parameters.section="Products"] - Index section
     * @param {string} [parameters.resultId] - Recommendation result identifier (returned in response from Constructor)
     * @param {number} [parameters.resultCount] - Total number of results
     * @param {number} [parameters.resultPage] - Page number of results
     * @param {number} [parameters.resultPositionOnPage] - Position of result on page
     * @param {number} [parameters.numResultsPerPage] - Number of results on page
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
     * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
     * @param {string[]|string|number} [parameters.seedItemIds] - Item ID(s) to be used as seed
     * @returns {(true|Error)}
     * @description User clicked an item that appeared within a list of recommended results
     * @example
     * constructorio.tracker.trackRecommendationClick(
     *     {
     *         variationId: 'KMH879-7632',
     *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         resultCount: 22,
     *         resultPage: 2,
     *         resultPositionOnPage: 2,
     *         numResultsPerPage: 12,
     *         podId: '019927c2-f955-4020',
     *         strategyId: 'complimentary',
     *         itemId: 'KMH876',
     *         itemName: 'Socks',
     *         seedItemIds: ['item-123', 'item-456'],
     *     },
     * );
     */
  }, {
    key: "trackRecommendationClick",
    value: function trackRecommendationClick(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/recommendation_result_click?");
        var bodyParams = {};
        var variation_id = parameters.variation_id,
          _parameters$variation6 = parameters.variationId,
          variationId = _parameters$variation6 === void 0 ? variation_id : _parameters$variation6,
          _parameters$section3 = parameters.section,
          section = _parameters$section3 === void 0 ? 'Products' : _parameters$section3,
          result_id = parameters.result_id,
          _parameters$resultId5 = parameters.resultId,
          resultId = _parameters$resultId5 === void 0 ? result_id : _parameters$resultId5,
          result_count = parameters.result_count,
          _parameters$resultCou4 = parameters.resultCount,
          resultCount = _parameters$resultCou4 === void 0 ? result_count : _parameters$resultCou4,
          result_page = parameters.result_page,
          _parameters$resultPag4 = parameters.resultPage,
          resultPage = _parameters$resultPag4 === void 0 ? result_page : _parameters$resultPag4,
          result_position_on_page = parameters.result_position_on_page,
          _parameters$resultPos2 = parameters.resultPositionOnPage,
          resultPositionOnPage = _parameters$resultPos2 === void 0 ? result_position_on_page : _parameters$resultPos2,
          num_results_per_page = parameters.num_results_per_page,
          _parameters$numResult4 = parameters.numResultsPerPage,
          numResultsPerPage = _parameters$numResult4 === void 0 ? num_results_per_page : _parameters$numResult4,
          pod_id = parameters.pod_id,
          _parameters$podId2 = parameters.podId,
          podId = _parameters$podId2 === void 0 ? pod_id : _parameters$podId2,
          strategy_id = parameters.strategy_id,
          _parameters$strategyI = parameters.strategyId,
          strategyId = _parameters$strategyI === void 0 ? strategy_id : _parameters$strategyI,
          item_id = parameters.item_id,
          _parameters$itemId7 = parameters.itemId,
          itemId = _parameters$itemId7 === void 0 ? item_id : _parameters$itemId7,
          item_name = parameters.item_name,
          _parameters$itemName5 = parameters.itemName,
          itemName = _parameters$itemName5 === void 0 ? item_name : _parameters$itemName5,
          analyticsTags = parameters.analyticsTags,
          slCampaignId = parameters.slCampaignId,
          slCampaignOwner = parameters.slCampaignOwner,
          seedItemIds = parameters.seedItemIds;
        if (variationId) {
          bodyParams.variation_id = variationId;
        }
        if (section) {
          bodyParams.section = section;
        }
        if (resultId) {
          bodyParams.result_id = resultId;
        }
        if (!helpers.isNil(resultCount)) {
          bodyParams.result_count = resultCount;
        }
        if (!helpers.isNil(resultPage)) {
          bodyParams.result_page = resultPage;
        }
        if (!helpers.isNil(resultPositionOnPage)) {
          bodyParams.result_position_on_page = resultPositionOnPage;
        }
        if (!helpers.isNil(numResultsPerPage)) {
          bodyParams.num_results_per_page = numResultsPerPage;
        }
        if (podId) {
          bodyParams.pod_id = podId;
        }
        if (strategyId) {
          bodyParams.strategy_id = strategyId;
        }
        if (itemId) {
          bodyParams.item_id = itemId;
        }
        if (itemName) {
          bodyParams.item_name = itemName;
        }
        if (analyticsTags) {
          bodyParams.analytics_tags = analyticsTags;
        }
        if (slCampaignId) {
          bodyParams.sl_campaign_id = slCampaignId;
        }
        if (slCampaignOwner) {
          bodyParams.sl_campaign_owner = slCampaignOwner;
        }
        if (typeof seedItemIds === 'number') {
          bodyParams.seed_item_ids = [String(seedItemIds)];
        } else if (seedItemIds !== null && seedItemIds !== void 0 && seedItemIds.length && typeof seedItemIds === 'string') {
          bodyParams.seed_item_ids = [seedItemIds];
        } else if (seedItemIds !== null && seedItemIds !== void 0 && seedItemIds.length && Array.isArray(seedItemIds)) {
          bodyParams.seed_item_ids = seedItemIds;
        }
        var requestURL = "".concat(requestPath).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send browse results loaded event to API
     *
     * @function trackBrowseResultsLoaded
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.url - Current page URL
     * @param {string} parameters.filterName - Filter name
     * @param {string} parameters.filterValue - Filter value
     * @param {object[]} parameters.items - List of product item objects
     * @param {string} [parameters.section="Products"] - Index section
     * @param {number} [parameters.resultCount] - Total number of results
     * @param {number} [parameters.resultPage] - Page number of results
     * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
     * @param {object} [parameters.selectedFilters] - Selected filters
     * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
     * @param {string} [parameters.sortBy] - Sorting method
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User viewed a browse product listing page
     * @example
     * constructorio.tracker.trackBrowseResultsLoaded(
     *     {
     *         resultCount: 22,
     *         resultPage: 2,
     *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         selectedFilters: { brand: ['foo'], color: ['black'] },
     *         sortOrder: 'ascending',
     *         sortBy: 'price',
     *         items: [{ itemId: 'KMH876' }, { itemId: 'KMH140' }],
     *         url: 'https://demo.constructor.io/sandbox/farmstand',
     *         filterName: 'brand',
     *         filterValue: 'XYZ',
     *     },
     * );
     */
  }, {
    key: "trackBrowseResultsLoaded",
    value: function trackBrowseResultsLoaded(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var _ref3;
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_result_load?");
        var bodyParams = {};
        var _parameters$section4 = parameters.section,
          section = _parameters$section4 === void 0 ? 'Products' : _parameters$section4,
          result_count = parameters.result_count,
          result_page = parameters.result_page,
          _parameters$resultPag5 = parameters.resultPage,
          resultPage = _parameters$resultPag5 === void 0 ? result_page : _parameters$resultPag5,
          result_id = parameters.result_id,
          _parameters$resultId6 = parameters.resultId,
          resultId = _parameters$resultId6 === void 0 ? result_id : _parameters$resultId6,
          selected_filters = parameters.selected_filters,
          _parameters$selectedF3 = parameters.selectedFilters,
          selectedFilters = _parameters$selectedF3 === void 0 ? selected_filters : _parameters$selectedF3,
          url = parameters.url,
          sort_order = parameters.sort_order,
          _parameters$sortOrder2 = parameters.sortOrder,
          sortOrder = _parameters$sortOrder2 === void 0 ? sort_order : _parameters$sortOrder2,
          sort_by = parameters.sort_by,
          _parameters$sortBy2 = parameters.sortBy,
          sortBy = _parameters$sortBy2 === void 0 ? sort_by : _parameters$sortBy2,
          filter_name = parameters.filter_name,
          _parameters$filterNam = parameters.filterName,
          filterName = _parameters$filterNam === void 0 ? filter_name : _parameters$filterNam,
          filter_value = parameters.filter_value,
          _parameters$filterVal = parameters.filterValue,
          filterValue = _parameters$filterVal === void 0 ? filter_value : _parameters$filterVal,
          items = parameters.items,
          analyticsTags = parameters.analyticsTags,
          _parameters$resultCou5 = parameters.resultCount,
          resultCount = _parameters$resultCou5 === void 0 ? (_ref3 = result_count !== null && result_count !== void 0 ? result_count : items === null || items === void 0 ? void 0 : items.length) !== null && _ref3 !== void 0 ? _ref3 : 0 : _parameters$resultCou5;
        if (section) {
          bodyParams.section = section;
        }
        if (!helpers.isNil(resultCount)) {
          bodyParams.result_count = resultCount;
        }
        if (!helpers.isNil(resultPage)) {
          bodyParams.result_page = resultPage;
        }
        if (resultId) {
          bodyParams.result_id = resultId;
        }
        if (selectedFilters) {
          bodyParams.selected_filters = selectedFilters;
        }
        if (url) {
          bodyParams.url = helpers.truncateString(url, MAX_URL_LENGTH);
        }
        if (sortOrder) {
          bodyParams.sort_order = sortOrder;
        }
        if (sortBy) {
          bodyParams.sort_by = sortBy;
        }
        if (filterName) {
          bodyParams.filter_name = filterName;
        }
        if (filterValue) {
          bodyParams.filter_value = filterValue;
        }
        if (items && Array.isArray(items)) {
          bodyParams.items = items.slice(0, 100).map(function (item) {
            return helpers.toSnakeCaseKeys(item, false);
          });
        }
        if (analyticsTags) {
          bodyParams.analytics_tags = analyticsTags;
        }
        var requestURL = "".concat(requestPath).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send browse result click event to API
     *
     * @function trackBrowseResultClick
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.filterName - Filter name
     * @param {string} parameters.filterValue - Filter value
     * @param {string} parameters.itemId - Product item unique identifier
     * @param {string} parameters.itemName - Product item name
     * @param {string} [parameters.section="Products"] - Index section
     * @param {string} [parameters.variationId] - Product item variation unique identifier
     * @param {string} [parameters.resultId] - Browse result identifier (returned in response from Constructor)
     * @param {number} [parameters.resultCount] - Total number of results
     * @param {number} [parameters.resultPage] - Page number of results
     * @param {number} [parameters.resultPositionOnPage] - Position of clicked item
     * @param {number} [parameters.numResultsPerPage] - Number of results shown
     * @param {object} [parameters.selectedFilters] -  Selected filters
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {string} [parameters.slCampaignId] - Pass campaign id of sponsored listing
     * @param {string} [parameters.slCampaignOwner] - Pass campaign owner of sponsored listing
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User clicked a result that appeared within a browse product listing page
     * @example
     * constructorio.tracker.trackBrowseResultClick(
     *     {
     *         variationId: 'KMH879-7632',
     *         resultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         resultCount: 22,
     *         resultPage: 2,
     *         resultPositionOnPage: 2,
     *         numResultsPerPage: 12,
     *         selectedFilters: { brand: ['foo'], color: ['black'] },
     *         filterName: 'brand',
     *         filterValue: 'XYZ',
     *         itemId: 'KMH876',
     *         slCampaignId: 'Campaign 123',
     *         slCampaignOwner: 'Store 123',
     *     },
     * );
     */
  }, {
    key: "trackBrowseResultClick",
    value: function trackBrowseResultClick(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_result_click?");
        var bodyParams = {};
        var _parameters$section5 = parameters.section,
          section = _parameters$section5 === void 0 ? 'Products' : _parameters$section5,
          variation_id = parameters.variation_id,
          _parameters$variation7 = parameters.variationId,
          variationId = _parameters$variation7 === void 0 ? variation_id : _parameters$variation7,
          result_id = parameters.result_id,
          _parameters$resultId7 = parameters.resultId,
          resultId = _parameters$resultId7 === void 0 ? result_id : _parameters$resultId7,
          result_count = parameters.result_count,
          _parameters$resultCou6 = parameters.resultCount,
          resultCount = _parameters$resultCou6 === void 0 ? result_count : _parameters$resultCou6,
          result_page = parameters.result_page,
          _parameters$resultPag6 = parameters.resultPage,
          resultPage = _parameters$resultPag6 === void 0 ? result_page : _parameters$resultPag6,
          result_position_on_page = parameters.result_position_on_page,
          _parameters$resultPos3 = parameters.resultPositionOnPage,
          resultPositionOnPage = _parameters$resultPos3 === void 0 ? result_position_on_page : _parameters$resultPos3,
          num_results_per_page = parameters.num_results_per_page,
          _parameters$numResult5 = parameters.numResultsPerPage,
          numResultsPerPage = _parameters$numResult5 === void 0 ? num_results_per_page : _parameters$numResult5,
          selected_filters = parameters.selected_filters,
          _parameters$selectedF4 = parameters.selectedFilters,
          selectedFilters = _parameters$selectedF4 === void 0 ? selected_filters : _parameters$selectedF4,
          filter_name = parameters.filter_name,
          _parameters$filterNam2 = parameters.filterName,
          filterName = _parameters$filterNam2 === void 0 ? filter_name : _parameters$filterNam2,
          filter_value = parameters.filter_value,
          _parameters$filterVal2 = parameters.filterValue,
          filterValue = _parameters$filterVal2 === void 0 ? filter_value : _parameters$filterVal2,
          customer_id = parameters.customer_id,
          _parameters$customerI4 = parameters.customerId,
          customerId = _parameters$customerI4 === void 0 ? customer_id : _parameters$customerI4,
          item_id = parameters.item_id,
          _parameters$itemId8 = parameters.itemId,
          itemId = _parameters$itemId8 === void 0 ? customerId || item_id : _parameters$itemId8,
          item_name = parameters.item_name,
          name = parameters.name,
          _parameters$itemName6 = parameters.itemName,
          itemName = _parameters$itemName6 === void 0 ? item_name || name : _parameters$itemName6,
          analyticsTags = parameters.analyticsTags,
          slCampaignId = parameters.slCampaignId,
          slCampaignOwner = parameters.slCampaignOwner;
        if (section) {
          bodyParams.section = section;
        }
        if (variationId) {
          bodyParams.variation_id = variationId;
        }
        if (resultId) {
          bodyParams.result_id = resultId;
        }
        if (!helpers.isNil(resultCount)) {
          bodyParams.result_count = resultCount;
        }
        if (!helpers.isNil(resultPage)) {
          bodyParams.result_page = resultPage;
        }
        if (!helpers.isNil(resultPositionOnPage)) {
          bodyParams.result_position_on_page = resultPositionOnPage;
        }
        if (!helpers.isNil(numResultsPerPage)) {
          bodyParams.num_results_per_page = numResultsPerPage;
        }
        if (selectedFilters) {
          bodyParams.selected_filters = selectedFilters;
        }
        if (filterName) {
          bodyParams.filter_name = filterName;
        }
        if (filterValue) {
          bodyParams.filter_value = filterValue;
        }
        if (itemId) {
          bodyParams.item_id = itemId;
        }

        // Ensure support for both item_name and name as parameters
        if (itemName) {
          bodyParams.item_name = itemName;
        }
        if (analyticsTags) {
          bodyParams.analytics_tags = analyticsTags;
        }
        if (slCampaignId) {
          bodyParams.sl_campaign_id = slCampaignId;
        }
        if (slCampaignOwner) {
          bodyParams.sl_campaign_owner = slCampaignOwner;
        }
        var requestURL = "".concat(requestPath).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send browse redirect event to API
     * @function trackBrowseRedirect
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.searchTerm - The search query that caused redirect
     * @param {string} parameters.filterName - Filter name of the browse page the user is redirected to. Should be the same value sent in `trackBrowseResultsLoaded`
     * @param {string} parameters.filterValue - Filter value of the browse page the user is redirected to. Should be the same value sent in `trackBrowseResultsLoaded`
     * @param {string} [parameters.userInput] - The text that a user had typed at the moment when submitting search request
     * @param {string} [parameters.redirectToUrl] - URL of the  page to which user is redirected
     * @param {string} [parameters.section="Products"] - Index section
     * @param {object} [parameters.selectedFilters] - Selected filters
     * @param {string} [parameters.sortOrder] - Sort order ('ascending' or 'descending')
     * @param {string} [parameters.sortBy] - Sorting method
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User got redirected to a browse product listing page
     * @example
     * constructorio.tracker.trackBrowseRedirect(
     *     {
     *         searchTerm: "books",
     *         filterName: 'brand',
     *         filterValue: 'XYZ',
     *         redirectToUrl: 'https://demo.constructor.io/books',
     *         selectedFilters: { brand: ['foo'], color: ['black'] },
     *         sortOrder: 'ascending',
     *         sortBy: 'price',
     *     },
     * );
     */
  }, {
    key: "trackBrowseRedirect",
    value: function trackBrowseRedirect(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/browse_redirect?");
        var bodyParams = {};
        var searchTerm = parameters.searchTerm,
          userInput = parameters.userInput,
          _parameters$section6 = parameters.section,
          section = _parameters$section6 === void 0 ? 'Products' : _parameters$section6,
          selectedFilters = parameters.selectedFilters,
          redirectToUrl = parameters.redirectToUrl,
          sortOrder = parameters.sortOrder,
          sortBy = parameters.sortBy,
          filterName = parameters.filterName,
          filterValue = parameters.filterValue,
          analyticsTags = parameters.analyticsTags;
        if (searchTerm) {
          bodyParams.search_term = searchTerm;
        }
        if (userInput) {
          bodyParams.user_input = userInput;
        }
        if (redirectToUrl) {
          bodyParams.redirect_to_url = redirectToUrl;
        }
        if (section) {
          bodyParams.section = section;
        }
        if (selectedFilters) {
          bodyParams.selected_filters = selectedFilters;
        }
        if (sortOrder) {
          bodyParams.sort_order = sortOrder;
        }
        if (sortBy) {
          bodyParams.sort_by = sortBy;
        }
        if (filterName) {
          bodyParams.filter_name = filterName;
        }
        if (filterValue) {
          bodyParams.filter_value = filterValue;
        }
        if (analyticsTags) {
          bodyParams.analytics_tags = analyticsTags;
        }
        var requestURL = "".concat(requestPath).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send generic result click event to API
     *
     * @function trackGenericResultClick
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.itemId - Product item unique identifier
     * @param {string} [parameters.itemName] - Product item name
     * @param {string} [parameters.variationId] - Product item variation unique identifier
     * @param {string} [parameters.section="Products"] - Index section
     * @param {object} [parameters.analyticsTags] - Pass additional analytics data
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User clicked a result that appeared outside of the scope of search / browse / recommendations
     * @example
     * constructorio.tracker.trackGenericResultClick(
     *     {
     *         itemId: 'KMH876',
     *         itemName: 'Red T-Shirt',
     *         variationId: 'KMH879-7632',
     *     },
     * );
     */
  }, {
    key: "trackGenericResultClick",
    value: function trackGenericResultClick(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure required parameters are provided
      if ((0, _typeof2["default"])(parameters) === 'object') {
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/result_click?");
        var bodyParams = {};
        var item_id = parameters.item_id,
          _parameters$itemId9 = parameters.itemId,
          itemId = _parameters$itemId9 === void 0 ? item_id : _parameters$itemId9,
          item_name = parameters.item_name,
          _parameters$itemName7 = parameters.itemName,
          itemName = _parameters$itemName7 === void 0 ? item_name : _parameters$itemName7,
          variation_id = parameters.variation_id,
          _parameters$variation8 = parameters.variationId,
          variationId = _parameters$variation8 === void 0 ? variation_id : _parameters$variation8,
          _parameters$section7 = parameters.section,
          section = _parameters$section7 === void 0 ? 'Products' : _parameters$section7,
          analyticsTags = parameters.analyticsTags;
        if (itemId) {
          bodyParams.section = section;
          bodyParams.item_id = itemId;
          if (itemName) {
            bodyParams.item_name = itemName;
          }
          if (variationId) {
            bodyParams.variation_id = variationId;
          }
          if (analyticsTags) {
            bodyParams.analytics_tags = analyticsTags;
          }
          var requestURL = "".concat(requestPath).concat(applyParamsAsString({}, this.options));
          var requestMethod = 'POST';
          var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
            requestMethod: requestMethod
          }));
          this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
          this.requests.send();
          return true;
        }
      }
      this.requests.send();
      return new Error('A parameters object with an "itemId" property is required.');
    }

    /**
     * Send quiz results loaded event to API
     *
     * @function trackQuizResultsLoaded
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.quizId - Quiz identifier
     * @param {string} parameters.quizVersionId - Quiz version identifier
     * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
     * @param {string} parameters.url - Current page url
     * @param {object[]} parameters.items - List of product item objects
     * @param {string} [parameters.section='Products'] - Index section
     * @param {number} [parameters.resultCount] - Total number of results
     * @param {number} [parameters.resultPage] - The page of the results
     * @param {string} [parameters.resultId] - Quiz result identifier (returned in response from Constructor)
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User viewed a quiz results page
     * @example
     * constructorio.tracker.trackQuizResultsLoaded(
     *     {
     *         quizId: 'coffee-quiz',
     *         quizVersionId: '1231244',
     *         quizSessionId: '3123',
     *         url: 'www.example.com',
     *         resultCount: 167,
     *         items: [{ itemId: 'KMH876', itemName: 'coffee' }, { itemId: 'KMH140', variationId: '123' }],
     *     },
     * );
     */
    // eslint-disable-next-line complexity
  }, {
    key: "trackQuizResultsLoaded",
    value: function trackQuizResultsLoaded(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_result_load?");
        var quiz_id = parameters.quiz_id,
          _parameters$quizId = parameters.quizId,
          quizId = _parameters$quizId === void 0 ? quiz_id : _parameters$quizId,
          quiz_version_id = parameters.quiz_version_id,
          _parameters$quizVersi = parameters.quizVersionId,
          quizVersionId = _parameters$quizVersi === void 0 ? quiz_version_id : _parameters$quizVersi,
          quiz_session_id = parameters.quiz_session_id,
          _parameters$quizSessi = parameters.quizSessionId,
          quizSessionId = _parameters$quizSessi === void 0 ? quiz_session_id : _parameters$quizSessi,
          url = parameters.url,
          _parameters$section8 = parameters.section,
          section = _parameters$section8 === void 0 ? 'Products' : _parameters$section8,
          result_count = parameters.result_count,
          _parameters$resultCou7 = parameters.resultCount,
          resultCount = _parameters$resultCou7 === void 0 ? result_count : _parameters$resultCou7,
          result_id = parameters.result_id,
          _parameters$resultId8 = parameters.resultId,
          resultId = _parameters$resultId8 === void 0 ? result_id : _parameters$resultId8,
          result_page = parameters.result_page,
          _parameters$resultPag7 = parameters.resultPage,
          resultPage = _parameters$resultPag7 === void 0 ? result_page : _parameters$resultPag7,
          items = parameters.items;
        var queryParams = {};
        var bodyParams = {};
        if (items && Array.isArray(items)) {
          bodyParams.items = items.slice(0, 100).map(function (item) {
            return helpers.toSnakeCaseKeys(item, false);
          });
        }
        if (typeof quizId !== 'string') {
          return new Error('"quizId" is a required parameter of type string');
        }
        if (typeof quizVersionId !== 'string') {
          return new Error('"quizVersionId" is a required parameter of type string');
        }
        if (typeof quizSessionId !== 'string') {
          return new Error('"quizSessionId" is a required parameter of type string');
        }
        if (typeof url !== 'string') {
          return new Error('"url" is a required parameter of type string');
        }
        bodyParams.quiz_id = quizId;
        bodyParams.quiz_version_id = quizVersionId;
        bodyParams.quiz_session_id = quizSessionId;
        bodyParams.url = helpers.truncateString(url, MAX_URL_LENGTH);
        if (!helpers.isNil(section)) {
          if (typeof section !== 'string') {
            return new Error('"section" must be a string');
          }
          queryParams.section = section;
          bodyParams.section = section;
        }
        if (!helpers.isNil(resultCount)) {
          if (typeof resultCount !== 'number') {
            return new Error('"resultCount" must be a number');
          }
          bodyParams.result_count = resultCount;
        }
        if (!helpers.isNil(resultId)) {
          if (typeof resultId !== 'string') {
            return new Error('"resultId" must be a string');
          }
          bodyParams.result_id = resultId;
        }
        if (!helpers.isNil(resultPage)) {
          if (typeof resultPage !== 'number') {
            return new Error('"resultPage" must be a number');
          }
          bodyParams.result_page = resultPage;
        }
        var requestURL = "".concat(requestPath).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send quiz result click event to API
     *
     * @function trackQuizResultClick
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.quizId - Quiz identifier
     * @param {string} parameters.quizVersionId - Quiz version identifier
     * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
     * @param {string} [parameters.itemId] - Product item unique identifier (Either itemId or itemName is required)
     * @param {string} [parameters.itemName] - Product item name
     * @param {string} [parameters.variationId] - Product variation unique identifier
     * @param {string} [parameters.section='Products'] - Index section
     * @param {number} [parameters.resultCount] - Total number of results
     * @param {number} [parameters.resultPage] - The page of the results
     * @param {string} [parameters.resultId] - Quiz result identifier (returned in response from Constructor)
     * @param {number} [parameters.resultPositionOnPage] - Position of clicked item
     * @param {number} [parameters.numResultsPerPage] - Number of results shown
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User viewed a quiz results page
     * @example
     * constructorio.tracker.trackQuizResultClick(
     *     {
     *         quizId: 'coffee-quiz',
     *         quizVersionId: '1231244',
     *         quizSessionId: '123',
     *         itemId: '123',
     *         itemName: 'espresso'
     *         variationId: '733431',
     *     },
     * );
     */
    // eslint-disable-next-line complexity
  }, {
    key: "trackQuizResultClick",
    value: function trackQuizResultClick(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_result_click?");
        var quiz_id = parameters.quiz_id,
          _parameters$quizId2 = parameters.quizId,
          quizId = _parameters$quizId2 === void 0 ? quiz_id : _parameters$quizId2,
          quiz_version_id = parameters.quiz_version_id,
          _parameters$quizVersi2 = parameters.quizVersionId,
          quizVersionId = _parameters$quizVersi2 === void 0 ? quiz_version_id : _parameters$quizVersi2,
          quiz_session_id = parameters.quiz_session_id,
          _parameters$quizSessi2 = parameters.quizSessionId,
          quizSessionId = _parameters$quizSessi2 === void 0 ? quiz_session_id : _parameters$quizSessi2,
          item_id = parameters.item_id,
          _parameters$itemId0 = parameters.itemId,
          itemId = _parameters$itemId0 === void 0 ? item_id : _parameters$itemId0,
          item_name = parameters.item_name,
          _parameters$itemName8 = parameters.itemName,
          itemName = _parameters$itemName8 === void 0 ? item_name : _parameters$itemName8,
          result_count = parameters.result_count,
          _parameters$resultCou8 = parameters.resultCount,
          resultCount = _parameters$resultCou8 === void 0 ? result_count : _parameters$resultCou8,
          result_id = parameters.result_id,
          _parameters$resultId9 = parameters.resultId,
          resultId = _parameters$resultId9 === void 0 ? result_id : _parameters$resultId9,
          result_page = parameters.result_page,
          _parameters$resultPag8 = parameters.resultPage,
          resultPage = _parameters$resultPag8 === void 0 ? result_page : _parameters$resultPag8,
          num_results_per_page = parameters.num_results_per_page,
          _parameters$numResult6 = parameters.numResultsPerPage,
          numResultsPerPage = _parameters$numResult6 === void 0 ? num_results_per_page : _parameters$numResult6,
          result_position_on_page = parameters.result_position_on_page,
          _parameters$resultPos4 = parameters.resultPositionOnPage,
          resultPositionOnPage = _parameters$resultPos4 === void 0 ? result_position_on_page : _parameters$resultPos4,
          _parameters$section9 = parameters.section,
          section = _parameters$section9 === void 0 ? 'Products' : _parameters$section9,
          variationId = parameters.variationId;
        var queryParams = {};
        var bodyParams = {};
        if (typeof quizId !== 'string') {
          return new Error('"quizId" is a required parameter of type string');
        }
        if (typeof quizVersionId !== 'string') {
          return new Error('"quizVersionId" is a required parameter of type string');
        }
        if (typeof quizSessionId !== 'string') {
          return new Error('"quizSessionId" is a required parameter of type string');
        }
        if (typeof itemId !== 'string' && typeof itemName !== 'string') {
          return new Error('"itemId" or "itemName" is a required parameter of type string');
        }
        bodyParams.quiz_id = quizId;
        bodyParams.quiz_version_id = quizVersionId;
        bodyParams.quiz_session_id = quizSessionId;
        if (!helpers.isNil(itemId)) {
          if (typeof itemId !== 'string') {
            return new Error('"itemId" must be a string');
          }
          bodyParams.item_id = itemId;
        }
        if (!helpers.isNil(itemName)) {
          if (typeof itemName !== 'string') {
            return new Error('"itemName" must be a string');
          }
          bodyParams.item_name = itemName;
        }
        if (!helpers.isNil(variationId)) {
          if (typeof variationId !== 'string') {
            return new Error('"variationId" must be a string');
          }
          bodyParams.variation_id = variationId;
        }
        if (!helpers.isNil(section)) {
          if (typeof section !== 'string') {
            return new Error('"section" must be a string');
          }
          queryParams.section = section;
        }
        if (!helpers.isNil(resultCount)) {
          if (typeof resultCount !== 'number') {
            return new Error('"resultCount" must be a number');
          }
          bodyParams.result_count = resultCount;
        }
        if (!helpers.isNil(resultId)) {
          if (typeof resultId !== 'string') {
            return new Error('"resultId" must be a string');
          }
          bodyParams.result_id = resultId;
        }
        if (!helpers.isNil(resultPage)) {
          if (typeof resultPage !== 'number') {
            return new Error('"resultPage" must be a number');
          }
          bodyParams.result_page = resultPage;
        }
        if (!helpers.isNil(numResultsPerPage)) {
          if (typeof numResultsPerPage !== 'number') {
            return new Error('"numResultsPerPage" must be a number');
          }
          bodyParams.num_results_per_page = numResultsPerPage;
        }
        if (!helpers.isNil(resultPositionOnPage)) {
          if (typeof resultPositionOnPage !== 'number') {
            return new Error('"resultPositionOnPage" must be a number');
          }
          bodyParams.result_position_on_page = resultPositionOnPage;
        }
        var requestURL = "".concat(requestPath).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send quiz conversion event to API
     *
     * @function trackQuizConversion
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.quizId - Quiz identifier
     * @param {string} parameters.quizVersionId - Quiz version identifier
     * @param {string} parameters.quizSessionId - Quiz session identifier associated with this conversion event
     * @param {string} [parameters.itemId] - Product item unique identifier (Either itemId or itemName is required)
     * @param {string} [parameters.itemName] - Product item name
     * @param {string} [parameters.variationId] - Product item variation unique identifier
     * @param {string} [parameters.revenue] - Sale price if available, otherwise the regular (retail) price of item
     * @param {string} [parameters.section='Products'] - Index section
     * @param {string} [parameters.type='add_to_cart'] - Conversion type
     * @param {boolean} [parameters.isCustomType] - Specify if type is custom conversion type
     * @param {string} [parameters.displayName] - Display name for the custom conversion type
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User viewed a quiz results page
     * @example
     * constructorio.tracker.trackQuizConversion(
     *     {
     *         quizId: 'coffee-quiz',
     *         quizVersionId: '1231244',
     *         quizSessionId: '3123',
     *         itemName: 'espresso',
     *         variationId: '167',
     *         type: 'add_to_cart',
     *         revenue: '1.0'
     *     },
     * );
     */
    // eslint-disable-next-line complexity
  }, {
    key: "trackQuizConversion",
    value: function trackQuizConversion(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/quiz_conversion?");
        var quiz_id = parameters.quiz_id,
          _parameters$quizId3 = parameters.quizId,
          quizId = _parameters$quizId3 === void 0 ? quiz_id : _parameters$quizId3,
          quiz_version_id = parameters.quiz_version_id,
          _parameters$quizVersi3 = parameters.quizVersionId,
          quizVersionId = _parameters$quizVersi3 === void 0 ? quiz_version_id : _parameters$quizVersi3,
          quiz_session_id = parameters.quiz_session_id,
          _parameters$quizSessi3 = parameters.quizSessionId,
          quizSessionId = _parameters$quizSessi3 === void 0 ? quiz_session_id : _parameters$quizSessi3,
          item_id = parameters.item_id,
          _parameters$itemId1 = parameters.itemId,
          itemId = _parameters$itemId1 === void 0 ? item_id : _parameters$itemId1,
          item_name = parameters.item_name,
          _parameters$itemName9 = parameters.itemName,
          itemName = _parameters$itemName9 === void 0 ? item_name : _parameters$itemName9,
          variation_id = parameters.variation_id,
          _parameters$variation9 = parameters.variationId,
          variationId = _parameters$variation9 === void 0 ? variation_id : _parameters$variation9,
          revenue = parameters.revenue,
          _parameters$section0 = parameters.section,
          section = _parameters$section0 === void 0 ? 'Products' : _parameters$section0,
          type = parameters.type,
          is_custom_type = parameters.is_custom_type,
          _parameters$isCustomT2 = parameters.isCustomType,
          isCustomType = _parameters$isCustomT2 === void 0 ? is_custom_type : _parameters$isCustomT2,
          display_name = parameters.display_name,
          _parameters$displayNa4 = parameters.displayName,
          displayName = _parameters$displayNa4 === void 0 ? display_name : _parameters$displayNa4;
        var queryParams = {};
        var bodyParams = {};

        // Ensure required parameters provided
        if (typeof quizId !== 'string') {
          return new Error('"quizId" is a required parameter of type string');
        }
        if (typeof quizVersionId !== 'string') {
          return new Error('"quizVersionId" is a required parameter of type string');
        }
        if (typeof quizSessionId !== 'string') {
          return new Error('"quizSessionId" is a required parameter of type string');
        }
        if (typeof itemId !== 'string' && typeof itemName !== 'string') {
          return new Error('"itemId" or "itemName" is a required parameter of type string');
        }
        bodyParams.quiz_id = quizId;
        bodyParams.quiz_version_id = quizVersionId;
        bodyParams.quiz_session_id = quizSessionId;
        if (!helpers.isNil(itemId)) {
          if (typeof itemId !== 'string') {
            return new Error('"itemId" must be a string');
          }
          bodyParams.item_id = itemId;
        }
        if (!helpers.isNil(itemName)) {
          if (typeof itemName !== 'string') {
            return new Error('"itemName" must be a string');
          }
          bodyParams.item_name = itemName;
        }
        if (!helpers.isNil(variationId)) {
          if (typeof variationId !== 'string') {
            return new Error('"variationId" must be a string');
          }
          bodyParams.variation_id = variationId;
        }
        if (!helpers.isNil(revenue)) {
          if (typeof revenue !== 'string') {
            return new Error('"revenue" must be a string');
          }
          bodyParams.revenue = revenue;
        }
        if (!helpers.isNil(section)) {
          if (typeof section !== 'string') {
            return new Error('"section" must be a string');
          }
          bodyParams.section = section;
        }
        if (!helpers.isNil(type)) {
          if (typeof type !== 'string') {
            return new Error('"type" must be a string');
          }
          bodyParams.type = type;
        }
        if (!helpers.isNil(isCustomType)) {
          if (typeof isCustomType !== 'boolean') {
            return new Error('"isCustomType" must be a boolean');
          }
          bodyParams.is_custom_type = isCustomType;
        }
        if (!helpers.isNil(displayName)) {
          if (typeof displayName !== 'string') {
            return new Error('"displayName" must be a string');
          }
          bodyParams.display_name = displayName;
        }
        var requestURL = "".concat(requestPath).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send ASA request submitted event
     *
     * @function trackAgentSubmit
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - Intent of user request
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User submitted an agent search
     *   (pressing enter within agent input element, or clicking agent submit element)
     * @example
     * constructorio.tracker.trackAgentSubmit(
     *     {
     *         intent: 'show me a recipe for a cookie',
     *     },
     * );
     */
  }, {
    key: "trackAgentSubmit",
    value: function trackAgentSubmit(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        // Ensure parameters are provided (required)
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_submit?");
        var section = parameters.section,
          intent = parameters.intent;
        var bodyParams = {
          intent: intent,
          section: section
        };
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send agent results page load started
     *
     * @function trackAgentResultLoadStarted
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - Intent of user request
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description Agent results page load begun (but has not necessarily loaded completely)
     * @example
     * constructorio.tracker.trackAgentResultLoadStarted(
     *     {
     *         intent: 'show me a recipe for a cookie',
     *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
     *     },
     * );
     */
  }, {
    key: "trackAgentResultLoadStarted",
    value: function trackAgentResultLoadStarted(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        // Ensure parameters are provided (required)
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_result_load_start?");
        var section = parameters.section,
          intentResultId = parameters.intentResultId,
          intent = parameters.intent;
        var bodyParams = {
          intent_result_id: intentResultId,
          intent: intent,
          section: section
        };
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send agent results page load finished
     *
     * @function trackAgentResultLoadFinished
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - Intent of user request
     * @param {number} parameters.searchResultCount - Number of search results loaded
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description Agent results page load finished
     * @example
     * constructorio.tracker.trackAgentResultLoadFinished(
     *     {
     *         intent: 'show me a recipe for a cookie',
     *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
     *         searchResultCount: 5,
     *     },
     * );
     */
  }, {
    key: "trackAgentResultLoadFinished",
    value: function trackAgentResultLoadFinished(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_result_load_finish?");
        var section = parameters.section,
          searchResultCount = parameters.searchResultCount,
          intentResultId = parameters.intentResultId,
          intent = parameters.intent;
        var bodyParams = {
          intent_result_id: intentResultId,
          section: section,
          intent: intent,
          search_result_count: searchResultCount
        };
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send agent result click event to API
     *
     * @function trackAgentResultClick
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - intent of the user
     * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
     * @param {string} parameters.itemId - Product item unique identifier
     * @param {string} parameters.itemName - Product item name
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {string} [parameters.variationId] - Product item variation unique identifier
     * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User clicked a result that appeared within an agent search result
     * @example
     * constructorio.tracker.trackAgentResultClick(
     *     {
     *         variationId: 'KMH879-7632',
     *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
     *         intent: 'show me a recipe for a cookie',
     *         itemId: 'KMH876',
     *     },
     * );
     */
  }, {
    key: "trackAgentResultClick",
    value: function trackAgentResultClick(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_result_click?");
        var _parameters$section1 = parameters.section,
          section = _parameters$section1 === void 0 ? 'Products' : _parameters$section1,
          variationId = parameters.variationId,
          intentResultId = parameters.intentResultId,
          searchResultId = parameters.searchResultId,
          itemId = parameters.itemId,
          itemName = parameters.itemName,
          intent = parameters.intent;
        var bodyParams = {
          section: section,
          variation_id: variationId,
          intent_result_id: intentResultId,
          search_result_id: searchResultId,
          item_id: itemId,
          item_name: itemName,
          intent: intent
        };
        var requestURL = "".concat(requestPath).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send agent search result view event to API
     *
     * @function trackAgentResultView
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - intent of the user
     * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
     * @param {number} parameters.numResultsViewed - Number of items viewed in this search result
     * @param {object[]} [parameters.items] - List of product item objects viewed
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User viewed a search result within an agent result
     * @example
     * constructorio.tracker.trackAgentResultView(
     *     {
     *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
     *         intent: 'show me a recipe for a cookie',
     *         numResultsViewed: 5,
     *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
     *     },
     * );
     */
  }, {
    key: "trackAgentResultView",
    value: function trackAgentResultView(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var requestPath = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_result_view?");
        var _parameters$section10 = parameters.section,
          section = _parameters$section10 === void 0 ? 'Products' : _parameters$section10,
          items = parameters.items,
          numResultsViewed = parameters.numResultsViewed,
          intentResultId = parameters.intentResultId,
          searchResultId = parameters.searchResultId,
          intent = parameters.intent;
        var bodyParams = {
          section: section,
          intent_result_id: intentResultId,
          search_result_id: searchResultId,
          num_results_viewed: numResultsViewed,
          items: items && Array.isArray(items) && items.slice(0, 100).map(function (item) {
            return helpers.toSnakeCaseKeys(item, false);
          }),
          intent: intent
        };
        var requestURL = "".concat(requestPath).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters are required of type object');
    }

    /**
     * Send ASA search submitted event
     *
     * @function trackAgentSearchSubmit
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - Intent of user request
     * @param {string} parameters.searchTerm - Term of submitted agent search event
     * @param {string} parameters.searchResultId - resultId of search result the clicked item belongs to
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {string} [parameters.intentResultId] - intentResultId from the ASA response
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User submitted an alternative agent search result search term
     * @example
     * constructorio.tracker.trackAgentSearchSubmit({
     *     {
     *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
     *         intent: 'show me a recipe for a cookie',
     *         searchTerm: 'flour',
     *     },
     * );
     */
  }, {
    key: "trackAgentSearchSubmit",
    value: function trackAgentSearchSubmit(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        // Ensure parameters are provided (required)
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/assistant_search_submit?");
        var section = parameters.section,
          intent = parameters.intent,
          searchTerm = parameters.searchTerm,
          searchResultId = parameters.searchResultId,
          intentResultId = parameters.intentResultId;
        var bodyParams = {
          intent: intent,
          section: section,
          search_term: searchTerm,
          search_result_id: searchResultId,
          intent_result_id: intentResultId
        };
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString({}, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters is a required parameter of type object');
    }

    /**
     * Send ASA request submitted event
     *
     * @deprecated This method will be removed in a future version. Use trackAgentSubmit instead.
     * @function trackAssistantSubmit
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - Intent of user request
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User submitted an assistant search
     *   (pressing enter within assistant input element, or clicking assistant submit element)
     * @example
     * constructorio.tracker.trackAssistantSubmit(
     *     {
     *         intent: 'show me a recipe for a cookie',
     *     },
     * );
     */
  }, {
    key: "trackAssistantSubmit",
    value: function trackAssistantSubmit(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.trackAgentSubmit(parameters, networkParameters);
    }

    /**
     * Send assistant results page load started
     *
     * @deprecated This method will be removed in a future version. Use trackAgentResultLoadStarted instead.
     * @function trackAssistantResultLoadStarted
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - Intent of user request
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description Assistant results page load begun (but has not necessarily loaded completely)
     * @example
     * constructorio.tracker.trackAssistantResultLoadStarted(
     *     {
     *         intent: 'show me a recipe for a cookie',
     *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
     *     },
     * );
     */
  }, {
    key: "trackAssistantResultLoadStarted",
    value: function trackAssistantResultLoadStarted(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.trackAgentResultLoadStarted(parameters, networkParameters);
    }

    /**
     * Send assistant results page load finished
     *
     * @deprecated This method will be removed in a future version. Use trackAgentResultLoadFinished instead.
     * @function trackAssistantResultLoadFinished
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - Intent of user request
     * @param {number} parameters.searchResultCount - Number of search results loaded
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {string} [parameters.intentResultId] - The intent result id from the ASA response
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description Assistant results page load finished
     * @example
     * constructorio.tracker.trackAssistantResultLoadFinished(
     *     {
     *         intent: 'show me a recipe for a cookie',
     *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
     *         searchResultCount: 5,
     *     },
     * );
     */
  }, {
    key: "trackAssistantResultLoadFinished",
    value: function trackAssistantResultLoadFinished(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.trackAgentResultLoadFinished(parameters, networkParameters);
    }

    /**
     * Send assistant result click event to API
     *
     * @deprecated This method will be removed in a future version. Use trackAgentResultClick instead.
     * @function trackAssistantResultClick
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - intent of the user
     * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
     * @param {string} parameters.itemId - Product item unique identifier
     * @param {string} parameters.itemName - Product item name
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {string} [parameters.variationId] - Product item variation unique identifier
     * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User clicked a result that appeared within an assistant search result
     * @example
     * constructorio.tracker.trackAssistantResultClick(
     *     {
     *         variationId: 'KMH879-7632',
     *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
     *         intent: 'show me a recipe for a cookie',
     *         itemId: 'KMH876',
     *     },
     * );
     */
  }, {
    key: "trackAssistantResultClick",
    value: function trackAssistantResultClick(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.trackAgentResultClick(parameters, networkParameters);
    }

    /**
     * Send assistant search result view event to API
     *
     * @deprecated This method will be removed in a future version. Use trackAgentResultView instead.
     * @function trackAssistantResultView
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - intent of the user
     * @param {string} parameters.searchResultId - result_id of the specific search result the clicked item belongs to
     * @param {number} parameters.numResultsViewed - Number of items viewed in this search result
     * @param {object[]} [parameters.items] - List of product item objects viewed
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {string} [parameters.intentResultId] - Browse result identifier (returned in response from Constructor)
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User viewed a search result within an assistant result
     * @example
     * constructorio.tracker.trackAssistantResultView(
     *     {
     *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
     *         intent: 'show me a recipe for a cookie',
     *         numResultsViewed: 5,
     *         items: [{itemId: 'KMH876'}, {itemId: 'KMH140'}, {itemId: 'KMH437'}],
     *     },
     * );
     */
  }, {
    key: "trackAssistantResultView",
    value: function trackAssistantResultView(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.trackAgentResultView(parameters, networkParameters);
    }

    /**
     * Send ASA search submitted event
     *
     * @deprecated This method will be removed in a future version. Use trackAgentSearchSubmit instead.
     * @function trackAssistantSearchSubmit
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.intent - Intent of user request
     * @param {string} parameters.searchTerm - Term of submitted assistant search event
     * @param {string} parameters.searchResultId - resultId of search result the clicked item belongs to
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {string} [parameters.intentResultId] - intentResultId from the ASA response
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User submitted an alternative assistant search result search term
     * @example
     * constructorio.tracker.trackAssistantSearchSubmit({
     *     {
     *         searchResultId: '019927c2-f955-4020-8b8d-6b21b93cb5a2',
     *         intentResultId: 'Zde93fd-f955-4020-8b8d-6b21b93cb5a2',
     *         intent: 'show me a recipe for a cookie',
     *         searchTerm: 'flour',
     *     },
     * );
     */
  }, {
    key: "trackAssistantSearchSubmit",
    value: function trackAssistantSearchSubmit(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return this.trackAgentSearchSubmit(parameters, networkParameters);
    }

    /**
     * Send product insights agent view events
     *
     * @function trackProductInsightsAgentViews
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {array.<{question: string}>} parameters.questions - List of pre-defined questions shown to the user
     * @param {string} parameters.itemId - Product id whose page we are on
     * @param {string} parameters.itemName - Product name whose page we are on
     * @param {array.<{start: string | undefined,
     * end: string | undefined}>} parameters.viewTimespans - List of timestamp pairs in ISO_8601 format
     * @param {string} [parameters.variationId] - Variation id whose page we are on
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description The product insights agent element appeared in the visible part of the page
     * @example
     * constructorio.tracker.trackProductInsightsAgentViews({
     *   {
     *     'itemId': '1',
     *     'itemName': 'item1',
     *     'variationId': '2',
     *     'questions': [
     *        { question: 'Why choose this?' },
     *        { question: 'How is this product made?' },
     *        { question: 'What are the dimensions of this product?' }
     *     ],
     *     'viewTimespans': [
     *       {
     *         'start': '2025-05-19T14:30:00+02:00',
     *         'end': '2025-05-19T14:30:05+02:00'
     *       },
     *       {
     *         'start': '2025-05-19T14:30:10+02:00',
     *         'end': '2025-05-19T14:30:15+02:00'
     *       }
     *     ]
     *   },
     * );
     */
  }, {
    key: "trackProductInsightsAgentViews",
    value: function trackProductInsightsAgentViews(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_views?");
        var section = parameters.section,
          questions = parameters.questions,
          itemId = parameters.itemId,
          itemName = parameters.itemName,
          variationId = parameters.variationId,
          viewTimespans = parameters.viewTimespans;
        var queryParams = {};
        var bodyParams = {
          questions: questions,
          item_id: itemId,
          item_name: itemName,
          variation_id: variationId,
          view_timespans: viewTimespans
        };
        if (section) {
          queryParams.section = section;
        }
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters is a required parameter of type object');
    }

    /**
     * Send product insights agent view event
     *
     * @function trackProductInsightsAgentView
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {array.<{question: string}>} parameters.questions - List of pre-defined questions shown to the user
     * @param {string} parameters.itemId - Product id whose page we are on
     * @param {string} parameters.itemName - Product name whose page we are on
     * @param {string} [parameters.variationId] - Variation id whose page we are on
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description The product insights agent element appeared in the visible part of the page
     * @example
     * constructorio.tracker.trackProductInsightsAgentView({
     *   {
     *     'itemId': '1',
     *     'itemName': 'item1',
     *     'variationId': '2',
     *     'questions': [
     *        { question: 'Why choose this?' },
     *        { question: 'How is this product made?' },
     *        { question: 'What are the dimensions of this product?' }
     *     ],
     *   },
     * );
     */
  }, {
    key: "trackProductInsightsAgentView",
    value: function trackProductInsightsAgentView(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_view?");
        var section = parameters.section,
          questions = parameters.questions,
          itemId = parameters.itemId,
          itemName = parameters.itemName,
          variationId = parameters.variationId;
        var queryParams = {};
        var bodyParams = {
          questions: questions,
          item_id: itemId,
          item_name: itemName,
          variation_id: variationId
        };
        if (section) {
          queryParams.section = section;
        }
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters is a required parameter of type object');
    }

    /**
     * Send product insights agent out of view event
     *
     * @function trackProductInsightsAgentOutOfView
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.itemId - Product id whose page we are on
     * @param {string} parameters.itemName - Product name whose page we are on
     * @param {string} [parameters.variationId] - Variation id whose page we are on
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description The product insights agent element disappeared from the visible part of the page
     * @example
     * constructorio.tracker.trackProductInsightsAgentOutOfView({
     *   {
     *     'itemId': '1',
     *     'itemName': 'item1',
     *     'variationId': '2',
     *   },
     * );
     */
  }, {
    key: "trackProductInsightsAgentOutOfView",
    value: function trackProductInsightsAgentOutOfView(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_out_of_view?");
        var section = parameters.section,
          itemId = parameters.itemId,
          itemName = parameters.itemName,
          variationId = parameters.variationId;
        var queryParams = {};
        var bodyParams = {
          item_id: itemId,
          item_name: itemName,
          variation_id: variationId
        };
        if (section) {
          queryParams.section = section;
        }
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters is a required parameter of type object');
    }

    /**
     * Send product insights agent input focus event
     *
     * @function trackProductInsightsAgentFocus
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.itemId - Product id whose page we are on
     * @param {string} parameters.itemName - Product name whose page we are on
     * @param {string} [parameters.variationId] - Variation id whose page we are on
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User focused on the product insights agent input element
     * @example
     * constructorio.tracker.trackProductInsightsAgentFocus({
     *   {
     *     'itemId': '1',
     *     'itemName': 'item1',
     *     'variationId': '2',
     *   },
     * );
     */
  }, {
    key: "trackProductInsightsAgentFocus",
    value: function trackProductInsightsAgentFocus(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_focus?");
        var section = parameters.section,
          itemId = parameters.itemId,
          itemName = parameters.itemName,
          variationId = parameters.variationId;
        var queryParams = {};
        var bodyParams = {
          item_id: itemId,
          item_name: itemName,
          variation_id: variationId
        };
        if (section) {
          queryParams.section = section;
        }
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters is a required parameter of type object');
    }

    /**
     * Send product insights agent question click event
     *
     * @function trackProductInsightsAgentQuestionClick
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.itemId - Product id whose page we are on
     * @param {string} parameters.itemName - Product name whose page we are on
     * @param {string} parameters.question - Question a user clicked on
     * @param {string} [parameters.variationId] - Variation id whose page we are on
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User clicked on a question within the product insights agent
     * @example
     * constructorio.tracker.trackProductInsightsAgentQuestionClick({
     *   {
     *     'itemId': '1',
     *     'itemName': 'item1',
     *     'variationId': '2',
     *     'question': 'Why choose this?'
     *   },
     * );
     */
  }, {
    key: "trackProductInsightsAgentQuestionClick",
    value: function trackProductInsightsAgentQuestionClick(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_question_click?");
        var section = parameters.section,
          itemId = parameters.itemId,
          itemName = parameters.itemName,
          variationId = parameters.variationId,
          question = parameters.question;
        var queryParams = {};
        var bodyParams = {
          item_id: itemId,
          item_name: itemName,
          variation_id: variationId,
          question: question
        };
        if (section) {
          queryParams.section = section;
        }
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters is a required parameter of type object');
    }

    /**
     * Send product insights agent question submit event
     *
     * @function trackProductInsightsAgentQuestionSubmit
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.itemId - Product id whose page we are on
     * @param {string} parameters.itemName - Product name whose page we are on
     * @param {string} parameters.question - Question a user submitted
     * @param {string} [parameters.variationId] - Variation id whose page we are on
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User submitted a question to the product insights agent
     * @example
     * constructorio.tracker.trackProductInsightsAgentQuestionSubmit({
     *   {
     *     'itemId': '1',
     *     'itemName': 'item1',
     *     'variationId': '2',
     *     'question': 'Tell me some key highlights about this item?'
     *   },
     * );
     */
  }, {
    key: "trackProductInsightsAgentQuestionSubmit",
    value: function trackProductInsightsAgentQuestionSubmit(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_question_submit?");
        var section = parameters.section,
          itemId = parameters.itemId,
          itemName = parameters.itemName,
          variationId = parameters.variationId,
          question = parameters.question;
        var queryParams = {};
        var bodyParams = {
          item_id: itemId,
          item_name: itemName,
          variation_id: variationId,
          question: question
        };
        if (section) {
          queryParams.section = section;
        }
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters is a required parameter of type object');
    }

    /**
     * Send product insights agent answer view event
     *
     * @function trackProductInsightsAgentAnswerView
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.itemId - Product id whose page we are on
     * @param {string} parameters.itemName - Product name whose page we are on
     * @param {string} parameters.question - Question a user submitted
     * @param {string} parameters.answerText - Answer text of the question
     * @param {string} [parameters.qnaResultId] - Answer result id returned
     * @param {string} [parameters.variationId] - Variation id whose page we are on
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description User viewed the answer provided by the product insights agent
     * @example
     * constructorio.tracker.trackProductInsightsAgentAnswerView({
     *   {
     *     'itemId': '1',
     *     'itemName': 'item1',
     *     'variationId': '2',
     *     'question': 'Why choose this?',
     *     'answerText': 'This product is awesome!',
     *     'qnaResultId': '0daf0015-fc29-4727-9140-8d5313a1902c',
     *   },
     * );
     */
  }, {
    key: "trackProductInsightsAgentAnswerView",
    value: function trackProductInsightsAgentAnswerView(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_answer_view?");
        var section = parameters.section,
          itemId = parameters.itemId,
          itemName = parameters.itemName,
          variationId = parameters.variationId,
          question = parameters.question,
          answerText = parameters.answerText,
          qnaResultId = parameters.qnaResultId;
        var queryParams = {};
        var bodyParams = {
          item_id: itemId,
          item_name: itemName,
          variation_id: variationId,
          question: question,
          answer_text: answerText,
          qna_result_id: qnaResultId
        };
        if (section) {
          queryParams.section = section;
        }
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters is a required parameter of type object');
    }

    /**
     * Send product insights agent answer feedback event
     *
     * @function trackProductInsightsAgentAnswerFeedback
     * @param {object} parameters - Additional parameters to be sent with request
     * @param {string} parameters.itemId - Product id whose page we are on
     * @param {string} parameters.itemName - Product name whose page we are on
     * @param {string} parameters.feedbackLabel - Feedback value: either "thumbs_up" or "thumbs_down"
     * @param {string} [parameters.qnaResultId] - Answer result id returned
     * @param {string} [parameters.variationId] - Variation id whose page we are on
     * @param {string} [parameters.section] - The section name for the item Ex. "Products"
     * @param {object} [networkParameters] - Parameters relevant to the network request
     * @param {number} [networkParameters.timeout] - Request timeout (in milliseconds)
     * @returns {(true|Error)}
     * @description A user provided feedback on an answers usefulness
     * @example
     * constructorio.tracker.trackProductInsightsAgentAnswerFeedback({
     *   {
     *     'itemId': '1',
     *     'itemName': 'item1',
     *     'variationId': '2',
     *     'feedbackLabel': 'thumbs_up',
     *     'qnaResultId': '0daf0015-fc29-4727-9140-8d5313a1902c',
     *   },
     * );
     */
  }, {
    key: "trackProductInsightsAgentAnswerFeedback",
    value: function trackProductInsightsAgentAnswerFeedback(parameters) {
      var networkParameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      // Ensure parameters are provided (required)
      if (parameters && (0, _typeof2["default"])(parameters) === 'object' && !Array.isArray(parameters)) {
        var baseUrl = "".concat(this.options.serviceUrl, "/v2/behavioral_action/product_insights_agent_answer_feedback?");
        var section = parameters.section,
          itemId = parameters.itemId,
          itemName = parameters.itemName,
          variationId = parameters.variationId,
          feedbackLabel = parameters.feedbackLabel,
          qnaResultId = parameters.qnaResultId;
        var queryParams = {};
        var bodyParams = {
          item_id: itemId,
          item_name: itemName,
          variation_id: variationId,
          feedback_label: feedbackLabel,
          qna_result_id: qnaResultId
        };
        if (section) {
          queryParams.section = section;
        }
        var requestURL = "".concat(baseUrl).concat(applyParamsAsString(queryParams, this.options));
        var requestMethod = 'POST';
        var requestBody = applyParams(bodyParams, _objectSpread(_objectSpread({}, this.options), {}, {
          requestMethod: requestMethod
        }));
        this.requests.queue(requestURL, requestMethod, requestBody, networkParameters);
        this.requests.send();
        return true;
      }
      this.requests.send();
      return new Error('parameters is a required parameter of type object');
    }

    /**
     * Subscribe to success or error messages emitted by tracking requests
     *
     * @function on
     * @param {string} messageType - Type of message to listen for ('success' or 'error')
     * @param {function} callback - Callback to be invoked when message received
     * @returns {(true|Error)}
     * @example
     * constructorio.tracker.on('error', (data) => {
     *     // Handle tracking error
     * });
     */
  }, {
    key: "on",
    value: function on(messageType, callback) {
      if (messageType !== 'success' && messageType !== 'error') {
        return new Error('messageType must be a string of value "success" or "error"');
      }
      if (!callback || typeof callback !== 'function') {
        return new Error('callback is required and must be a function');
      }
      this.eventemitter.on(messageType, callback);
      return true;
    }
  }]);
}(); // Exposed for testing
Tracker.RequestQueue = RequestQueue;
module.exports = Tracker;